import React from 'react';
import { Box, Grid, Typography, Paper, Link } from '@mui/material';
import { ClinicalTrialsModel } from '../../../../../models/data-sections/clinical-trials/clinicalTrialsModel';
import { ClinicalTrialsStudiesModel } from '../../../../../models/data-sections/clinical-trials/studiesModel';

interface StudyDetailsProps {
  selected_study: ClinicalTrialsModel;
  study_details?: ClinicalTrialsStudiesModel | null;
}

const StudyDetails: React.FC<StudyDetailsProps> = ({ selected_study, study_details }) => {
  if (!selected_study) {
    return <Typography>No selected_study data available.</Typography>;
  }

  const clinicalTrialsUrl = `https://clinicaltrials.gov/ct2/show/${selected_study.nct_id}`;

  // Helper function to format date
  const formatDate = (dateString: string | null | undefined): string =>
    dateString ? dateString.split('T')[0] : 'N/A';

  return (
    <Paper
      elevation={3}
      sx={{
        padding: 3,
        borderRadius: '8px',
        margin: '16px auto',
        maxWidth: '95%',
        width: '100%',
      }}
    >
      <Grid container spacing={2}>
        {/* Left Column */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            NCT ID
          </Typography>
          <Link href={clinicalTrialsUrl} target="_blank" rel="noopener noreferrer" underline="hover">
            {selected_study.nct_id}
          </Link>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Completion Date
          </Typography>
          <Typography>{formatDate(selected_study.completion_date)}</Typography>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Enrollment
          </Typography>
          <Typography>{selected_study.enrollment || 'N/A'}</Typography>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Last Update Posted Date
          </Typography>
          <Typography>{formatDate(selected_study.last_update_posted_date)}</Typography>
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            Outcomes Count
          </Typography>
          <Typography>{selected_study.outcomes_count || 'N/A'}</Typography>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Overall Status
          </Typography>
          <Typography>{selected_study.overall_status || 'N/A'}</Typography>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Phase
          </Typography>
          <Typography>{selected_study.phase || 'N/A'}</Typography>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Source
          </Typography>
          <Typography>{selected_study.source || 'N/A'}</Typography>

          <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
            Sponsors Count
          </Typography>
          <Typography>{selected_study.sponsors_count || 'N/A'}</Typography>
        </Grid>
      </Grid>

      {/* Brief Title Section */}
      <Box
        sx={{
          mt: 4,
          p: 2,
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
        }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          Official Title
        </Typography>
        <Typography>{study_details?.official_title || 'N/A'}</Typography>
      </Box>
    </Paper>
  );
};

export default StudyDetails;
